import { groupBy, orderBy } from "lodash";
import { Features } from "~/apps/shared/consts";
import { Product } from "./models";

export const getSaleNumber = (sale, features) => {
  return !features.includes(Features.FHI) ? sale.number : sale.numberSixDigit
}

export const getCompanyFieldLabel = (features: string[] = []) => {
  if (features.includes(Features.REPLACE_COMPANY_WITH_CARRIER) || features.includes(Features.FHI)) {
    return "Carrier";
  } else {
    return "Company";
  }
};

export const getGroupedProducts = (products: Product[]) => {
  const productsInGroups: Product[] = [];
  const items: Product[] = [];

  products.forEach((product) => {
    if (product.group?.id) {
      productsInGroups.push(product);
    } else {
      items.push(product);
    }
  });

  const groups = Object.values(groupBy(productsInGroups, (item) => `${item.group?.id}_${item.locationId}`));

  if (!!items.length) {
    groups.push(items);
  }

  return groups.map((group) => orderBy(group, [(item) => item.priority ?? Infinity], ["asc"]));
};